import type React from 'react';

import type { Uuid } from '@vlabs/api/luna-api/model';
import type { WithDataTestid, WithClassNameProp } from '@vlabs/uikit/types';
import cn from 'classnames';

import { useFaceAttributesQuery } from '@vlabs/monokit/entities/events/api';
import { AgeAttributeCard, GenderAttributeCard } from '@vlabs/monokit/shared/ui/atribute-cards';

import { useEventAttributesTranslation } from './i18n';
import st from './shared.module.sass';
import { buildTestid } from '../../../shared/lib/utils';

interface TopMatchFaceAttributesProps extends WithDataTestid, WithClassNameProp {
  faceId: Uuid;
}

const displayName = 'TopMatchFaceAttributes';
const testid = buildTestid(displayName);

function TopMatchFaceAttributes({
  faceId,
  className = undefined,
  'data-testid': dataTestId = undefined,
}: TopMatchFaceAttributesProps): React.JSX.Element {
  const { t } = useEventAttributesTranslation();
  const { data: attributes } = useFaceAttributesQuery(faceId);

  if (!attributes) return <span className={st.NoData}>{t('no_data')}</span>;

  const { age, gender } = attributes;

  return (
    <div
      className={cn(st.Attributes, className)}
      {...testid(dataTestId)}
    >
      {!!age && (
        <AgeAttributeCard
          age={age as never}
          className={st.AttributeCard}
        />
      )}

      {!!gender && (
        <GenderAttributeCard
          className={st.AttributeCard}
          gender={gender as never}
        />
      )}
    </div>
  );
}

TopMatchFaceAttributes.displayName = displayName;

export { TopMatchFaceAttributes };
